<template>
  <v-card>
    <v-toolbar flat dense class="card-bar">
      <v-toolbar-title>Trips</v-toolbar-title>
      <v-btn icon small class="ml-2" @click="reload">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer />
      <OHoldToConfirm
        color="orange"
        :height="32"
        :progressSize="20"
        label="Force-Close"
      />
    </v-toolbar>

    <VisDialog ref="visDialog" />

    <OLoadingLine absolute :value="isLoading" />

    <OPaginatedTable
      class="fixed-table dense-table"
      dense
      :spec="spec"
      :items="rows"
      :count="count"
      :navigation="nav"
      @update:navigation="updateNav"
      @rowClicked="showTrip"
    />

    <OAlert error v-if="err != null">{{ err }}</OAlert>
  </v-card>
</template>

<script>
import OLoadingLine from 'oderon-vue/cpts/OLoadingLine'
import OPaginatedTable from 'oderon-vue/cpts/OPaginatedTable'
import VisDialog from '@/views/vis/VisDialog'
import { brDateTime, brNum, sDuration } from 'oderon-commons/src/formatters'
import UnpauserStore from './UnpauserStore'
import OHoldToConfirm from 'oderon-vue/cpts/OHoldToConfirm.vue'

const _check = 'mdi-checkbox-marked-circle',
  _cross = 'mdi-close-circle',
  _green = 'green--text icon-small',
  _red = 'red--text icon-small',
  _valid = { iconText: _check, iconClass: _green },
  _invalid = { iconText: _cross, iconClass: _red }

export default {
  components: {
    OLoadingLine,
    OPaginatedTable,
    VisDialog,
    OHoldToConfirm
  },
  computed: {
    isLoading() {
      return UnpauserStore.trips.isLoading
    },
    rows() {
      return UnpauserStore.trips.rows
    },
    count() {
      return UnpauserStore.trips.count
    },
    nav() {
      return UnpauserStore.trips.nav
    },
    err() {
      return UnpauserStore.trips.err
    }
  },
  data() {
    return {
      spec: {
        columns: [
          { t: 'ID|', d: 'id', w: 90 },
          { t: '||', d: 'isValid', w: 40, f: (v) => (v ? _valid : _invalid) },
          { t: 'Início|', d: 'startTimestamp', w: 130, f: brDateTime },
          { t: 'Motorista', d: 'driver.name' },
          { t: 'Duração|', d: 'durationS', w: 100, f: sDuration },
          { t: 'Dist.(m)|', d: 'distanceM', w: 100, f: brNum }
        ],
        rowClass: (r) => {
          return r.isOngoing ? 'blue lighten-4' : ''
        },
        defaultSortable: false
      }
    }
  },

  methods: {
    updateNav(x) {
      UnpauserStore.paginateTrips(x)
    },

    reload() {
      UnpauserStore.fetchTrips()
    },

    async showTrip(row) {
      await this.$refs.visDialog.open({
        orgId: UnpauserStore.client.vehicle.orgId,
        tripId: row.id
      })
    }
  }
}
</script>

<style></style>
